export const formatAmount = (value) => {
  const trimmedValue = value.trim();

  if (!Number.isNaN(Number(trimmedValue))) {
    if (/^\d+$/.test(trimmedValue)) {
      return trimmedValue.replace(/^0+/, '') || '0';
    }
  }

  return trimmedValue;
};
